import { render, staticRenderFns } from "./OsobaDodatnaAktivnostEdit.vue?vue&type=template&id=02c97770&scoped=true&"
import script from "./OsobaDodatnaAktivnostEdit.vue?vue&type=script&lang=js&"
export * from "./OsobaDodatnaAktivnostEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c97770",
  null
  
)

export default component.exports